import { defineMessages } from "react-intl";

export const messages = defineMessages({
    filterDsps: {
        id: "dsps.settings.dsps-filter",
        defaultMessage: "Filter by DSP",
    },
});
